module.exports = __webpack_public_path__ + "dbc427638dc478894d27503f078ac7f9.png";